import { Box, Container, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { designTokens } from "../../../theme/designTokens";
import { teamMembers } from "../../../theme/aboutContent";
import type { TeamMember } from "../../../theme/aboutContent";

const { colors, fonts, spacing } = designTokens;

const SECTION_BG = "#353535";

type TeamCardProps = {
  member: TeamMember;
};

const TeamCard = ({ member }: TeamCardProps) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <Box
      onMouseEnter={() => setFlipped(true)}
      onMouseLeave={() => setFlipped(false)}
      onClick={() => setFlipped((prev) => !prev)}
      sx={{
        perspective: "1000px",
        width: "100%",
        maxWidth: 269,
        height: 317,
        mx: "auto",
        cursor: "pointer",
        filter: "drop-shadow(0px 4px 2px #FE7915)",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
          transformStyle: "preserve-3d",
          transition: "transform 0.6s",
          transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backfaceVisibility: "hidden",
            backgroundColor: colors.white,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pt: 5,
            px: 2,
          }}
        >
          <Box
            component="img"
            src={member.photo}
            alt={member.name}
            sx={{
              width: 124,
              height: 121,
              borderRadius: "50%",
              objectFit: "cover",
              mb: 2,
            }}
          />
          <Typography
            sx={{
              fontWeight: fonts.weights.bold,
              fontSize: "1.25rem",
              lineHeight: "20px",
              color: colors.textPrimary,
              textAlign: "center",
            }}
          >
            {member.name}
          </Typography>
          <Typography
            sx={{
              fontWeight: fonts.weights.bold,
              fontSize: "1rem",
              lineHeight: "20px",
              color: colors.primary,
              textAlign: "center",
              mt: 1,
            }}
          >
            {member.role}
          </Typography>
        </Box>

        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backfaceVisibility: "hidden",
            transform: "rotateY(180deg)",
            backgroundColor: colors.primary,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: 2,
          }}
        >
          <Typography
            sx={{
              fontWeight: fonts.weights.bold,
              fontSize: { xs: "0.875rem", md: "1rem" },
              lineHeight: "25px",
              color: colors.white,
              textAlign: "center",
            }}
          >
            {member.bio}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

const TeamSection = () => (
  <Box sx={{ backgroundColor: SECTION_BG, py: { xs: 6, md: 8 } }}>
    <Container maxWidth={spacing.containerMax}>
      <Box sx={{ textAlign: "center", mb: { xs: 4, md: 6 } }}>
        <Typography
          sx={{
            fontWeight: 900,
            fontSize: { xs: "2rem", md: "3rem" },
            lineHeight: "60px",
            color: colors.white,
            mb: 1,
          }}
        >
          OUR TEAM
        </Typography>
        {/* <Typography
          sx={{
            fontWeight: 900,
            fontSize: { xs: "2rem", md: "3rem" },
            lineHeight: "60px",
            color: colors.primary,
          }}
        >
          Meet Our Team
        </Typography> */}
      </Box>

      <Grid container spacing={{ xs: 4, md: 3 }} justifyContent="center">
        {teamMembers.map((member) => (
          <Grid item xs={12} sm={6} md={4} key={member.name}>
            <TeamCard member={member} />
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default TeamSection;
